import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from '@mui/styles';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useSnackbar } from "notistack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
// import {
//   MuiPickersUtilsProvider,
// } from "@mui/x-date-pickers";
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {
  Button,
  Dialog,
  FormControl,
  FormLabel,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  List,
  ListItem,
  IconButton
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getSearchEndDate,
  getSearchStartDate,
  setSearchStartDate,
  setSearchEndDate,
} from "Redux/DashboardVariables";
import { callGetEvents } from "APILayer/ManuDashboardAPIs/ApiGetEvents";

const materialTheme = createTheme({
  components: {
    // MuiIconButton: {
    //   styleOverrides: {
    //     sizeMedium: {
    //       color: 'red'
    //     }
    //   }
    // },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: 'Lato'
        }
      }
    },
    // MuiInputLabel: {
    //   styleOverrides: {
    //     root: {
    //       color: 'red'
    //     }
    //   }
    // }
  },
  overrides: {
    MuiPickersLayout: {
      root: { backgroundColor: 'black' },
      toolbar: { backgroundColor: 'black', color: 'green' }
    },
    MuiPickersToolbar: {
      fontFamily: "Lato",
      toolbar: {
        fontFamily: "Lato",
        backgroundColor: "#000",
      },
    },
    MuiPickersCalendarHeader: {
      fontFamily: "Lato",
      switchHeader: {
      },
    },
    MuiPickersDay: {
      fontFamily: "Lato",
      day: {
        color: "#000",
      },
      daySelected: {
        backgroundColor: "#000",
        "&:hover": {
          backgroundColor: "#000",
        },
      },
      dayDisabled: {
        color: "#000",
      },
      current: {
        color: "#000",
      },
    },
    MuiPickersModal: {
      dialogAction: {
        fontFamily: "Lato",
        color: "#000",
        MuiButtonTextPrimary: {
          color: "#000",
        },
      },
    },
  },
});
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: '10px',
  },
  addspace: {
    margin: '10px',
  },
  button: {
    margin: '10px',
  },
  closeButton: {
    position: "absolute",
    right: '10px',
    top: '10px',
    color: 'lightgray',
  },
}));

const MIN_DATE = "2021-08-03 00:00";

export default function DateComponent({
  onUpdateCallback = () => { },
  isMonitor = false,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const dispatch = useDispatch();
  const searchStartDate = useSelector(getSearchStartDate);
  const searchEndDate = useSelector(getSearchEndDate);

  const [error, setError] = React.useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const handleClose = () => {
    setModalOpen(false);
  };
  const handleClickOpen = () => {
    setModalOpen(true);
  };

  function pad2(n) {
    return (n < 10 ? "0" : "") + n;
  }

  const todayMidNight = dayjs().set('hour', 23).endOf('hour');

  // console.log(new Date(searchStartDate).getTime());
  // this data will be shown in the calendar/custom hh:mm popup button
  const handleFormat = (currDate) => {
    let getYear = new Date(currDate).getFullYear();
    let getMonths = new Date(currDate).getMonth() + 1;
    let getDate = new Date(currDate).getDate();
    return pad2(getYear) + "/" + pad2(getMonths) + "/" + pad2(getDate);
  };
  // console.log(handleFormat(selectedDate))
  const validateStartEndTime = () => {
    // minimum date - 01-08-2021 12:00AM EST in epoch
    let minumumDate = 1627790400000;
    let currentDate = new Date().setHours(0, 0, 0, 0);
    let start = new Date(searchStartDate);
    let end = new Date(searchEndDate);
    if (currentDate < minumumDate) {
      enqueueSnackbar("Date should not be before minimal date", {
        variant: "warning",
      });
    } else if (start.getTime() !== 0 && end.getTime() !== 0) {
      if (end.getTime() - start.getTime() < 0) {
        enqueueSnackbar(
          "Selected End Date/Time must be greater than selected Start Date/Time",
          {
            variant: "warning",
          }
        );
        return false;
      } else {

        let dayDuration = 86400000;
        let duration = end.getTime() - start.getTime();
        // Check if date is different
        let sameDates =
          start.getFullYear() === end.getFullYear() &&
          start.getMonth() === end.getMonth() &&
          start.getDate() === end.getDate();

        if (!isMonitor) {
          dispatch(callGetEvents({}))
          onUpdateCallback();
        }
        handleClose();
      }
    }
  };

  const clearDate = () => {
    dispatch(setSearchStartDate(new Date(new Date().getTime() - 3600 * 1000)));
    dispatch(setSearchEndDate(new Date()));
  };

  const handleEndDate = (newDate) => {
    let endDate = new Date(newDate);
    dispatch(setSearchEndDate(endDate.getTime()));
  };

  const handleStartDate = (newDate) => {
    let startDate = new Date(newDate);
    dispatch(setSearchStartDate(startDate.getTime()));
  };

  const displayDates = () => {
    let startDate = new Date(searchStartDate);
    let endDate = new Date(searchEndDate);
    let dayDuration = 86400000;
    let duration = endDate.getTime() - startDate.getTime();
    let showDates = "";

    let sameDates =
      startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getDate() === endDate.getDate();

    if (sameDates && duration < dayDuration) {
      showDates =
        handleFormat(searchStartDate) +
        " " +
        pad2(startDate.getHours()) +
        ":" +
        pad2(startDate.getMinutes()) +
        " - " +
        pad2(endDate.getHours()) +
        ":" +
        pad2(endDate.getMinutes());
    } else {
      showDates =
        handleFormat(searchStartDate) + " - " + handleFormat(searchEndDate);
    }
    return showDates;
  };

  const [displayDate, setDisplayDate] = useState(displayDates());
  useEffect(() => {
    setDisplayDate(displayDates());
  }, [searchStartDate, searchEndDate]);

  // console.log('display date: ', displayDate, searchStartDate, searchEndDate);

  return (
    <div style={{ display: "inline" }}>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={handleClickOpen}
        style={{
          margin: "10px 10px 0 10px",
          width: "250px",
          height: "40px",
          backgroundColor: "white",
          border: "solid",
          borderColor: "lightgray",
          borderWidth: "1px",
        }}
        disableElevation
        id="datecomponent"
      >
        <span style={{ color: 'gray' }}>{displayDate}</span>
        <div className="datealign">
          <div style={{ marginTop: "-5px", fontWeight: "500" }}>
          </div>
          <div>
            <CalendarTodayIcon
              style={{ marginTop: "5px", marginLeft: '10px', float: "right", color: "#c7c7c7" }}
            />
          </div>
        </div>
      </Button>

      <Dialog
        open={modalOpen}
        disableEscapeKeyDown
        aria-labelledby="max-width-dialog-title"
        style={{ position: 'absolute' }}
      >
        <DialogTitle id="customized-dialog-title">
          Select Date & Time
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              handleClose();
            }}
            id="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={"div"}>
            <Grid container item xs={12} style={{ margin: "0 0" }}>
              <Grid item xs={12}>
                <FormControl
                  component="fieldset"
                  error={error}
                // className={classes.formControl}
                >
                  <List component="nav" aria-label="main mailbox folders">
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Time Window</FormLabel>

                      <ListItem button style={{ cursor: 'pointer' }}>
                        <ThemeProvider theme={materialTheme}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileDateTimePicker
                              // timeSteps={{ hours: 1, minutes: 1 }}
                              maxDateTime={todayMidNight}
                              defaultValue={dayjs(new Date().setHours(0, 0, 0, 0))}
                              value={dayjs(searchStartDate)}
                              onChange={(newValue) => {
                                if (new Date(newValue).getTime() < new Date().getTime()) {
                                  dispatch(setSearchStartDate(new Date(newValue)));
                                }
                              }}
                              className="custom-mobile-datetime-picker"
                            />
                          </LocalizationProvider>
                        </ThemeProvider>
                        <div style={{ width: '10px' }}></div>
                        <ThemeProvider theme={materialTheme}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDateTimePicker
                            // timeSteps={{ hours: 1, minutes: 1 }}
                            maxDateTime={todayMidNight}
                            defaultValue={dayjs(new Date().setHours(0, 0, 0, 0))}
                            value={dayjs(searchEndDate)}
                            onChange={(newValue) => {
                              dispatch(setSearchEndDate(new Date(newValue)));
                            }}
                            
                          />
                        </LocalizationProvider>
                        </ThemeProvider>
                      </ListItem>
                    </FormControl>
                  </List>
                  <ListItem
                    style={{ justifyContent: "center", marginTop: "9px" }}
                  >

                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        validateStartEndTime();
                      }}
                      id="update"
                      style={{
                        backgroundColor: '#17B696',
                        color: "white",
                        // marginLeft: "27px",
                        marginRight: "15px",
                        textTransform: 'none',
                        boxShadow: 'none'
                      }}
                    >
                      Update
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        clearDate();
                      }}
                      id="reset"
                      style={{
                        width: "79px",
                        backgroundColor: 'lightgray',
                        textTransform: 'none',
                        boxShadow: 'none'
                      }}
                    >
                      Reset
                    </Button>

                  </ListItem>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
